import T from '../../services/language';
import {Container, ContainerView, ContainerViewFooter} from "../../components/Container";
import {NextButton} from "../../components/Button";
import styled from "styled-components";
import {Control, ControlRow, InputView, LabelView2, LabelViewSub, TextAreaView} from "./style";
import {useEffect, useState} from "react";
import {useApp} from "../../contexts/app";
import {Header} from "../../components/Header";
import Step from "../../components/Step";
import {useNavigate, useParams} from "react-router-dom";
import {message} from "antd";
import useStateAsync from "use-state-async";
import {CacheScheduleService, getAddressByPostalCode} from "../../services/app";
import useSessionCompleted from "../../hooks/completed";

export default function PortalCode(props: any) {
    const [value, setValue, putValue] = useStateAsync({
        postalCode: "",
        unitNo: "",
        address: ""
    });
    const [error, setError] = useState("");
    let {
        groupSlug,
        shareUrlKey,
        campaignId,
        customerId,
        productServiceId,
        productServiceType,
        quantity,
        packageIndex, locationType, productServiceTemplateId
    } = useParams();
    const navigate = useNavigate();
    const {setLocalAddress, getLocalAddress, setLoading, clientCode, removeCurrentBookings} = useApp();
    const sessionCompleted = useSessionCompleted();

    useEffect(() => {
        setValue(getLocalAddress(customerId));
    }, [customerId])

    const onNext = () => {
        if (value.postalCode?.length !== 6) {
            message.error(T("Postal Code invalid format!"));
            return;
        }
        if (!value.unitNo?.length) {
            message.error(T("Please key in your unit number, if your house doesn't have an unit number, please key in 00!"));
            return;
        }
        CacheScheduleService.clear();
        removeCurrentBookings();
        setLocalAddress(customerId, value);
        navigate(`/${groupSlug}/${shareUrlKey}/${campaignId}/${customerId}/product-and-service/${productServiceType}/${productServiceId}/${productServiceTemplateId}/${quantity}/booking/${locationType}/${0}/${value.postalCode}`);
    }

    const onLoadAddress = async () => {
        if (value.postalCode?.length !== 6) {
            return;
        }
        setLoading(true);
        const result = await getAddressByPostalCode(value.postalCode).catch(reason => null);
        if (result?.data?.data?.address) {
            putValue('address', result?.data?.data?.address)
        }
        setLoading(false);
    }

    return (
        <Container style={{height: '100%'}}>
            <Header title={T("Location")} back right={(<Step current={1} dotStyle/>)}/>

            <ContainerView
                style={{height: 'calc(100% - 100px)', paddingTop: 1}}>
                <div style={{display: "flex", flexDirection: 'column', justifyContent: 'space-between', flex: 1}}>
                    {
                        !!error ? (
                            <DescWarn
                                style={{marginTop: 12}}>{T('Sorry, your address is not in the service area')}</DescWarn>
                        ) : (
                            <Desc
                                style={{marginTop: 12}}>{T('Please enter your postal code to view available sessions')}</Desc>
                        )
                    }
                    <ControlRow>
                        <Control>
                            <LabelView2>{T('Postal Code')}</LabelView2>
                            <InputView onBlur={() => {
                                onLoadAddress().then()
                            }} value={value.postalCode} onChange={event => {
                                const postalCode = (event.target.value || "").substring(0, 6).replace(/\D/g, '');
                                putValue('postalCode', postalCode)
                            }}/>
                        </Control>
                        <div style={{width: 12}}/>
                        <Control>
                            <LabelView2>{T('Unit No.')}</LabelView2>
                            <InputView value={value.unitNo}
                                       onChange={event => {
                                           const unitNo = (event.target.value || "").replace(/[^\d#-]/g, '');
                                           putValue('unitNo', unitNo)
                                       }}/>
                        </Control>
                    </ControlRow>
                    <Control>
                        <LabelView2 style={{marginBottom: 1}}>{T('Address')}</LabelView2>
                        <LabelViewSub>
                            {T("*This is an onsite booking, please key in your address")}
                        </LabelViewSub>
                        <TextAreaView value={value.address} autoSize={{minRows: 3, maxRows: 12}}
                                      onChange={event => putValue('address', event.target.value)}/>
                    </Control>
                </div>

                <ContainerViewFooter>
                    <NextButton onClick={() => {
                        onNext()
                    }}>{T('Next')}</NextButton>
                </ContainerViewFooter>
            </ContainerView>
        </Container>
    )
}

const Desc = styled.div`
    margin: 32px 0 24px 0;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #494949;
`;
const DescWarn = styled(Desc)`
    color: #C51A1A;
`;
const Label = styled.div`
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: #494949;
    margin-bottom: 4px;
`;
const Input = styled(InputView)`
    height: 80px;
    font-weight: 600;
    font-size: 20px;
    line-height: 30px;
    color: #494949;
    text-align: center;

    &.error {
        background: #FFEEEE;
        border: 1px solid #C51A1A;
        color: #C51A1A;
    }
`;

const Image = styled((props: any) => (
    <svg {...props} width="250" height="250" viewBox="0 0 250 250" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_4721_82194)">
            <rect width="250" height="250" rx="125" fill="#F0F8F4"/>
            <g clipPath="url(#clip1_4721_82194)">
                <path
                    d="M192.129 175.88C190.143 147.13 177.327 134.923 172.812 122.913C171.727 120.026 171.009 117.007 170.675 113.938L170.664 113.837C169.982 107.502 165.746 105.145 161.231 106.236L161.531 71.8559C161.563 68.1646 160.156 64.6875 157.571 62.0656C154.985 59.4436 151.536 58 147.863 58H97.6708C90.1325 58 84 64.1623 84 71.7373V180.494C84 188.069 90.1325 194.231 97.6708 194.231H126.608C135.149 200.815 145.167 206.011 155.903 207.593C175.621 234.077 190.174 258.232 191.318 260.001L194.973 258.033C220.091 244.501 229.902 222.284 231 220.793C229.281 219.072 209.626 203.952 192.131 175.88H192.129Z"
                    fill="white"/>
                <path
                    d="M152.809 141.66C153.276 135.202 156.463 114.798 160.642 111.362C161.96 110.278 165.691 109.058 166.272 114.419C166.644 117.858 167.451 121.249 168.668 124.486C173.587 137.572 186.151 148.721 187.778 177.28C197.965 193.83 210.575 208.872 225.369 221.776C217.899 235.149 206.94 246.533 192.88 254.107C182.25 237.004 170.974 220.307 158.319 203.41C141.613 201.652 126.721 190.288 115.641 177.713C126.692 165.184 138.039 152.918 152.807 141.659L152.809 141.66Z"
                    fill="#FFAD92"/>
                <path
                    d="M88.4307 71.7362V180.494C88.4307 185.622 92.5677 189.78 97.6709 189.78H146.912C151.983 189.78 156.106 185.672 156.151 180.576L157.102 71.8197C157.148 66.6606 152.997 62.4536 147.863 62.4536H97.6709C92.5677 62.4536 88.4307 66.6108 88.4307 71.7389V71.7362Z"
                    fill="#2F967B"/>
                <path
                    d="M153.005 71.7807L152.051 180.54C152.028 183.359 149.72 185.66 146.914 185.66H97.6734C94.839 185.66 92.5312 183.341 92.5312 180.493V71.7389C92.5312 68.8907 94.839 66.5718 97.6734 66.5718H103.49C103.847 69.9384 106.682 72.5577 110.131 72.5577H135.405C138.855 72.5577 141.684 69.9384 142.041 66.5718H147.863C149.245 66.5718 150.539 67.1131 151.512 68.1016C152.484 69.0847 153.017 70.3909 153.005 71.7807Z"
                    fill="#F0F8F4"/>
                <path
                    d="M122.768 117.16C134.325 117.16 143.694 107.746 143.694 96.1322C143.694 84.5186 134.325 75.104 122.768 75.104C111.21 75.104 101.841 84.5186 101.841 96.1322C101.841 107.746 111.21 117.16 122.768 117.16Z"
                    fill="#88CBBA"/>
                <path
                    d="M122.768 181.733C134.325 181.733 143.694 172.319 143.694 160.705C143.694 149.091 134.325 139.677 122.768 139.677C111.21 139.677 101.841 149.091 101.841 160.705C101.841 172.319 111.21 181.733 122.768 181.733Z"
                    fill="#88CBBA"/>
                <path
                    d="M120.739 143.201L104.744 157.748H108.846V171.795C108.846 174.064 110.677 175.902 112.934 175.902C113.604 175.902 133.236 175.902 132.599 175.902C134.857 175.902 136.686 174.063 136.686 171.795V157.748H140.789L124.794 143.201C123.643 142.154 121.887 142.154 120.736 143.201H120.739Z"
                    fill="#FF605B"/>
                <path
                    d="M119.099 160.705H126.436C126.885 160.705 127.249 161.071 127.249 161.523V175.904H118.285V161.523C118.285 161.071 118.65 160.705 119.099 160.705Z"
                    fill="#C72F55"/>
                <path
                    d="M138.782 96.2981C138.782 87.1771 131.233 79.8297 122.071 80.2189C113.96 80.5636 107.318 87.0775 106.785 95.2181C106.648 97.3027 106.911 99.3079 107.498 101.168C107.916 102.901 110.216 110.114 121.07 119.943C122.029 120.811 123.494 120.813 124.453 119.943C135.117 110.286 137.525 103.154 138.002 101.263C138.507 99.6984 138.782 98.0312 138.782 96.2981Z"
                    fill="#40A68C"/>
                <path
                    d="M122.768 106.884C128.677 106.884 133.467 102.071 133.467 96.1326C133.467 90.1946 128.677 85.3809 122.768 85.3809C116.858 85.3809 112.068 90.1946 112.068 96.1326C112.068 102.071 116.858 106.884 122.768 106.884Z"
                    fill="white"/>
                <path
                    d="M116.292 96.5124L119.536 101.579C120.243 102.681 121.844 102.692 122.565 101.599L128.976 91.8731C129.401 91.2294 129.234 90.3621 128.6 89.9245C127.967 89.4868 127.102 89.639 126.655 90.2679L120.929 98.3115L118.661 94.9422C118.212 94.2742 117.302 94.1126 116.652 94.5853C116.041 95.0297 115.883 95.8754 116.291 96.5124H116.292Z"
                    fill="#7AD001"/>
                <path
                    d="M157.501 188.27C151.934 174.952 155.296 148.673 155.442 147.56C155.514 147.007 156.022 146.615 156.569 146.69C157.119 146.763 157.507 147.271 157.434 147.823C157.4 148.09 153.998 174.673 159.355 187.486C159.569 188.001 159.329 188.592 158.817 188.809C158.3 189.027 157.714 188.778 157.501 188.269V188.27Z"
                    fill="#ED6C4D"/>
                <path
                    d="M122.768 138.125C122.213 138.125 121.763 137.673 121.763 137.115V122.838C121.763 122.281 122.213 121.828 122.768 121.828C123.323 121.828 123.773 122.281 123.773 122.838V137.115C123.773 137.673 123.323 138.125 122.768 138.125Z"
                    fill="#88CBBA"/>
            </g>
        </g>
        <defs>
            <clipPath id="clip0_4721_82194">
                <rect width="250" height="250" rx="125" fill="white"/>
            </clipPath>
            <clipPath id="clip1_4721_82194">
                <rect width="147" height="202" fill="white" transform="translate(84 58)"/>
            </clipPath>
        </defs>
    </svg>
))`
    margin: 64px auto 32px auto;
`
